module.exports = __webpack_public_path__ + "img/section2-4.fef69a81.png";